import React, { useState, useEffect, useRef } from 'react';
import {
  Button,
  Card,
  Col,
  Form,
  Input,
  Row,
  Select,
  Tag,
  Typography,
  message,
} from 'antd';
// import moment from 'moment-timezone';
import { injectIntl, useIntl } from 'react-intl';
// import { updateAuthUser } from '../../redux/actions/AuthActions';
import { updateUser, changePassword } from '../../redux/actions/UserAction';
import IntlMessages from '../../components/IntlMessage';
import PageTitle from '../../components/PageTitle';
import UploadAvatar from '../../components/UploadAvatar';
import LayoutContent from '../../components/LayoutContent';
import { useSelector } from 'react-redux';

const { Option } = Select;
const { Title, Text } = Typography;

const Profile = () => {
  const authUser = useSelector((state) => state.auth.authUser);
  const intl = useIntl();
  const formRef = useRef();
  // const timezones = moment.tz.names();

  const [loadingChangePW, setLoadingChangePW] = useState(false);
  const [loadingUpdateInfo, setLoadingUpdateInfo] = useState(false);
  // const [idImage, setIdImage] = useState([]);
  // const [activeTab, setActiveTab] = useState('general');
  // const [loading, setLoading] = useState(true);

  // useEffect(() => {
  //   if (authUser) {
  //     setIdImage(authUser.id_image ? authUser.id_image : []);
  //   }
  // }, [authUser]);

  // useEffect(() => {
  //   setLoading(false);
  // }, []);

  const handleSubmit = (values) => {
    // console.log(values.new_password);

    setLoadingChangePW(true);
    changePassword(values)
      .then(() => {
        message.success({
          content: intl.formatMessage({ id: 'global.save_success' }),
        });
        formRef.current.resetFields();
        setLoadingChangePW(false);
      })
      .catch(() => {
        message.error({
          content: intl.formatMessage({ id: 'global.save_failed' }),
        });
        setLoadingChangePW(false);
      });
  };

  const handleSubmitInfo = (values) => {
    setLoadingUpdateInfo(true);
    const data = {
      ...values,
    };

    updateUser(authUser.id, data)
      .then(() => {
        message.success({
          content: intl.formatMessage({ id: 'global.save_success' }),
        });
        formRef.current.resetFields();
        setLoadingUpdateInfo(false);
      })
      .catch(() => {
        message.error({
          content: intl.formatMessage({ id: 'global.save_failed' }),
        });
        setLoadingUpdateInfo(false);
      });
  };

  const setName = (account) => {
    if (account) {
      let name = '';
      if (account.fullname) {
        name = account.fullname;
      } else {
        if (account.firstname) name = name + ' ' + account.firstname;
        if (account.lastname) name = name + ' ' + account.lastname;
      }
      if (name) return name;
      return intl.formatMessage({ id: 'global.user' });
    }
  };

  // console.log(authUser);

  return (
    <>
      <LayoutContent>
        <PageTitle title={<IntlMessages id="global.account_information" />} />
        <Row gutter={24}>
          <Col lg={6} sm={24}>
            <Card hoverable className="card-without-padding">
              <div className="your-img">
                <UploadAvatar />
                <Title level={3} className="your-name">
                  {setName(authUser)}
                </Title>
                <Tag className="mt-2">{authUser.email}</Tag>
              </div>
            </Card>
          </Col>
          <Col>
            <Row gutter={[24, 24]}>
              <Col span={24}>
                <Card hoverable>
                  <Typography.Title level={4}>
                    <IntlMessages id="global.account_information" />
                  </Typography.Title>

                  <Form
                    ref={formRef}
                    layout="vertical"
                    onFinish={handleSubmitInfo}
                    initialValues={
                      authUser
                        ? {
                            ...authUser,
                          }
                        : null
                    }>
                    <Row gutter={24}>
                      <Col span={12}>
                        <Form.Item
                          label={<IntlMessages id="global.firstname" />}
                          name="firstname"
                          rules={[
                            {
                              required: true,
                              message: (
                                <IntlMessages id="global.requiredfield" />
                              ),
                            },
                          ]}>
                          <Input />
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item
                          label={<IntlMessages id="global.lastname" />}
                          name="lastname"
                          rules={[
                            {
                              required: true,
                              message: (
                                <IntlMessages id="global.requiredfield" />
                              ),
                            },
                          ]}>
                          <Input />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row gutter={24}>
                      <Col span={12}>
                        <Form.Item
                          label={<IntlMessages id="global.email" />}
                          name="email"
                          rules={[
                            {
                              required: true,
                              message: (
                                <IntlMessages id="global.requiredfield" />
                              ),
                            },
                          ]}>
                          <Input
                            disabled={
                              authUser && authUser.email_verified === 1
                                ? true
                                : false
                            }
                          />
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item
                          label={<IntlMessages id="global.mobile" />}
                          name="mobile"
                          rules={[
                            {
                              required: true,
                              message: (
                                <IntlMessages id="global.requiredfield" />
                              ),
                            },
                          ]}>
                          <Input />
                        </Form.Item>
                      </Col>
                    </Row>

                    {/* <Row gutter={24}>
                      <Col span={12}>
                        <Form.Item
                          label={<IntlMessages id="global.language" />}
                          name="language"
                          rules={[
                            {
                              required: true,
                              message: (
                                <IntlMessages id="global.requiredfield" />
                              ),
                            },
                          ]}
                        >
                          <Select style={{ width: '100%' }}>
                            <Option value="en-US">English</Option>
                            <Option value="vi-VN">Vietnamese</Option>
                          </Select>
                        </Form.Item>
                      </Col>
                    </Row> */}

                    <Form.Item>
                      <Button
                        type="primary"
                        htmlType="submit"
                        loading={loadingUpdateInfo}>
                        <IntlMessages id="global.save" />
                      </Button>
                    </Form.Item>
                  </Form>
                </Card>
              </Col>
              <Col span={24}>
                <Card hoverable>
                  <Typography.Title level={4}>
                    <IntlMessages id="global.changepassword" />
                  </Typography.Title>
                  <Form layout="vertical" onFinish={handleSubmit} ref={formRef}>
                    <Form.Item
                      label={<IntlMessages id="global.current_password" />}
                      name="old_password"
                      rules={[
                        {
                          required: true,
                          message: <IntlMessages id="global.requiredfield" />,
                        },
                      ]}>
                      <Input.Password />
                    </Form.Item>

                    <Form.Item
                      label={<IntlMessages id="global.new_password" />}
                      name="new_password"
                      rules={[
                        {
                          required: true,
                          message: <IntlMessages id="global.requiredfield" />,
                        },
                        {
                          min: 6,
                          message: (
                            <IntlMessages id="global.password_min_charactor" />
                          ),
                        },
                      ]}>
                      <Input.Password />
                    </Form.Item>

                    <Form.Item
                      label={<IntlMessages id="global.confirm_new_password" />}
                      name="confirm_new_password"
                      dependencies={['new_password']}
                      hasFeedback
                      rules={[
                        {
                          min: 6,
                          message: (
                            <IntlMessages id="global.password_min_charactor" />
                          ),
                        },
                        {
                          required: true,
                          message: <IntlMessages id="global.requiredfield" />,
                        },

                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            if (
                              !value ||
                              getFieldValue('new_password') === value
                            ) {
                              return Promise.resolve();
                            }
                            return Promise.reject(
                              intl.formatMessage({
                                id: 'global.password_not_match',
                              }),
                            );
                          },
                        }),
                      ]}>
                      <Input.Password />
                    </Form.Item>

                    <Form.Item>
                      <Button
                        type="primary"
                        htmlType="submit"
                        loading={loadingChangePW}>
                        <IntlMessages id="global.save" />
                      </Button>
                    </Form.Item>
                  </Form>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
      </LayoutContent>
    </>
  );
};

export default injectIntl(Profile);
